<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="'Bimbingan '+title">
            <br>
            <common-training-header :withUser="false"/>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :columns="columns"
                :dataSource="items.outlines"
                rowKey="hash"
                :loading="loading"
                :pagination="false"
                bordered>

                <div slot="outline" slot-scope="record" style="text-align: left">
                    {{ record.title }}
                </div>

                <div slot="status" slot-scope="text, record, index">
                    <div v-if="record.files_count > 0">
                        <a-tag v-if="record.files[0].approved_level == 2" color="green">
                            Sudah Disetujui
                        </a-tag>
                        <a-tag v-else-if="record.files[0].approved_level == 1 && record.files[0].response_time == null" color="blue">
                            Proses Review Pembimbing
                        </a-tag>
                        <a-tag v-else-if="record.files[0].approved_level == 0 && record.files[0].response_time == null" color="blue">
                            Proses Review Mentor
                        </a-tag>
                        <a-tag v-else color="red">
                            Belum Disetujui
                        </a-tag>
                    </div>
                </div>

                <div slot="bimbingan" slot-scope="record">
                    {{ record.files_count }}
                </div>

                <div slot="last_date" slot-scope="record">
                    <div v-if="record.files.length > 0 && record.files[0].approved_level == 2">
                        {{ moment(record.files[0].approved_date).format('DD-MM-YYYY HH:mm:ss') }}
                    </div>
                </div>

                <div slot="action" slot-scope="text, record, index" style="text-align: left">
                    <div v-if="index == 0">
                        <template v-if="record.files_count > 0">
                            <a-button size="small" block @click="history(record.hash)">
                                History
                            </a-button>
                        </template>
                        <template v-else>
                            <a-button size="small" block @click="history(record.hash)">
                                Upload
                            </a-button>
                        </template>
                    </div>
                    <div v-else-if="items.outlines[index-1].files.length != 0 && items.outlines[index-1].files[0].approved_level == 2">
                        <div></div>
                        <template v-if="record.files_count > 0">
                            <a-button size="small" block @click="history(record.hash)">
                                History
                            </a-button>
                        </template>
                        <template v-else>
                            <a-button size="small" block @click="history(record.hash)">
                                Upload
                            </a-button>
                        </template>
                    </div>
                </div>
            </a-table>

            <a-descriptions style="margin-top: 32px" bordered>
                <a-descriptions-item :label="'Presentasi & ' + title" v-if="outline != 'evaluation'">
                    <a-space>
                        <div>
                            <a-button type="link" size="small" @click="download(items.activity.presentation_file)" v-if="items.activity.presentation_file != null">
                                <a-icon type="file-ppt" theme="twoTone" two-tone-color="#eb3437" /> Download
                            </a-button>
                        </div>
                        <a-button type="dashed" icon="plus" @click="showModal('presentation')" block :disabled="!lastOutlineApproved"> Upload Presentasi</a-button>
                    </a-space>
                    <br><br>
                    <a-space>
                        <div>
                            <a-button type="link" size="small" @click="download(items.activity.presentation_outline_file)" v-if="items.activity.presentation_outline_file != null">
                                <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                            </a-button>
                        </div>
                        <a-button type="dashed" icon="plus" @click="showModal('presentation_outline')" block :disabled="!lastOutlineApproved"> Upload {{ title }} </a-button>
                    </a-space>
                </a-descriptions-item>

                <a-descriptions-item label="Presentasi Evaluasi Kinerja" v-else>
                    <a-space>
                        <div>
                            <a-button type="link" size="small" @click="download(items.activity.presentation_file)" v-if="items.activity.presentation_file != null">
                                <a-icon type="file-ppt" theme="twoTone" two-tone-color="#eb3437" /> Download
                            </a-button>
                        </div>
                        <a-button type="dashed" icon="plus" @click="showModal('presentation')" block :disabled="!lastOutlineApproved"> Upload Presentasi</a-button>
                    </a-space>
                </a-descriptions-item>

                <a-descriptions-item :label="'Revisi Presentasi & ' + title" v-if="outline != 'evaluation'">
                    <a-space>
                        <div>
                            <a-button type="link" size="small" @click="download(items.activity.revision_file)" v-if="items.activity.revision_file != null">
                                <a-icon type="file-ppt" theme="twoTone" two-tone-color="#eb3437" /> Download
                            </a-button>
                        </div>
                        <a-button type="dashed" icon="plus" @click="showModal('revision')" :disabled="!isScored" block> Upload Revisi Presentasi</a-button>
                    </a-space>
                    <br><br>
                    <a-space>
                        <div>
                            <a-button type="link" size="small" @click="download(items.activity.revision_outline_file)" v-if="items.activity.revision_outline_file != null">
                                <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                            </a-button>
                        </div>
                        <a-button type="dashed" icon="plus" @click="showModal('revision_outline')" :disabled="!isScored" block> Upload Revisi {{ title }}</a-button>
                    </a-space>
                </a-descriptions-item>

                <a-descriptions-item label="Revisi Presentasi Evaluasi Kinerja" v-else>
                    <a-space>
                        <div>
                            <a-button type="link" size="small" @click="download(items.activity.revision_file)" v-if="items.activity.revision_file != null">
                                <a-icon type="file-ppt" theme="twoTone" two-tone-color="#eb3437" /> Download
                            </a-button>
                        </div>
                        <a-button type="dashed" icon="plus" @click="showModal('revision')" :disabled="!isScored" block> Upload Revisi Presentasi</a-button>
                    </a-space>
                </a-descriptions-item>
            </a-descriptions>
        </a-card>

        <a-modal
            :visible="visible"
            :destroyOnClose="true"
            :footer="null"
            :closable="false"
        >
            <a-card type="inner" size="small">
                <a-form :form="form" :layout="formLayout" @submit="handleSubmit">
                    <a-divider dashed orientation="left"
                    ><font style="color: red">*</font> Upload</a-divider>
                    <a-form-item>
                        <a-upload
                            :file-list="fileList"
                            :remove="handleRemove"
                            :before-upload="beforeUpload"
                            @change="handleChange"
                        >
                            <a-button>
                                <a-icon type="upload" /> Select File
                            </a-button>
                        </a-upload>
                    </a-form-item>
                    <a-form-item>
                        <a-row type="flex" justify="center" align="top">
                            <a-col>
                                <a-space>
                                    <a-button
                                        type="primary"
                                        html-type="submit"
                                        :loading="processing"
                                        :disabled="processing"
                                    >Submit</a-button>
                                    <a-button
                                        @click="handleClose"
                                        :loading="processing"
                                        :disabled="processing"
                                    >Tutup</a-button>
                                </a-space>
                            </a-col>
                        </a-row>
                    </a-form-item>
                </a-form>
            </a-card>
        </a-modal>
    </div>
</template>

<script>
const columns = [
    {
        key: 'outline',
        title: 'Outline',
        align: 'center',
        scopedSlots: {customRender: 'outline'},
    }, {
        key: 'status',
        title: 'Status',
        align: 'center',
        scopedSlots: {customRender: 'status'}
    }, {
        key: 'bimbingan',
        title: 'Bimbingan',
        align: 'center',
        scopedSlots: {customRender: 'bimbingan'}
    }, {
        key: 'last_date',
        title: 'Tanggal Approve',
        align: 'center',
        scopedSlots: {customRender: 'last_date'}
    }, {
        key: 'action',
        title: 'Action',
        align: 'center',
        scopedSlots: {customRender: 'action'}
    }
]

export default {
    props: {
        outline: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            columns,
            items: {
                outlines: [
                    {
                        files: []
                    }
                ],
                activity: {
                    scores_count: 0
                }
            },
            loading: false,
            visible: false,
            reupload: false,
            processing: false,
            type: null,
            file: null,
            fileList: [],
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
        }
    },
    created() {
        this.getItems()
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        isScored() {
            return this.items.activity.is_scored
        },
        lastOutlineApproved() {
            if(this.items.outlines[this.items.outlines.length-1].files.length > 0 
                && this.items.outlines[this.items.outlines.length-1].files[0].approved_level == 2){
                    return this.items.activity.has_scores == 0
                }

            return false
        },
        title(){
            switch(this.outline) {
                case "proposal":
                    return "Proposal"
                case "project_evaluation":
                    return "Evaluasi Project"
                case "evaluation":
                    return "Evaluasi Kinerja"
                default:
                    return "Makalah"
            }
        }
    },
    methods: {
        getItems() {
            this.loading = true;

            let params = this.activeModule.module.identifier == 'paper' || this.activeModule.module.identifier == 'evaluation' ? null : {
                params: {
                    outline: this.outline
                }
            }

            this.$http
                .get(this.routeUri("api.activity.guidance"), params)
                .then(response => this.items = response.data)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        history(hash){
            let params = {
                outline: this.outline,
                hash: hash
            }

            window.location.href = this.routeUri('admin.' + this.activeModule.module.identifier + '.guidance.history') + '?' + this.$qs.stringify(params)
        },
        showModal(type, reupload = false, file_id = null, ) {
            this.type = type
            this.reupload = reupload
            this.file = file_id
            this.visible = true;
        },
        handleClose(isRefresh) {
            this.visible = false;

            this.fileList = []

            if (isRefresh == true) {
                this.getItems();
            }
        },
        handleSubmit(e) {
            e.preventDefault(e);

            this.form.validateFields((err, formData) => {
                if (!err) {
                    this.processing = true;

                    let promise;

                    var data = new FormData();

                    for (var k in formData) {
                        if (formData.hasOwnProperty(k)) {
                            data.append(k, formData[k]);
                        }
                    }

                    data.append("attachment", this.fileList[0]);
                    data.append("type", this.type);

                    if(this.reupload == true){
                        promise = this.$http.post(
                            this.routeUri("api.activity-doc.reupload", {
                                file: this.file,
                                activity: this.items.activity.id
                            }),
                            data
                        );
                    }else{
                        promise = this.$http.post(
                            this.routeUri("api.activity-doc.upload", {
                                activity: this.items.activity.id
                            }),
                            data
                        );
                    }

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false));
                }
            });
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.handleClose(true), 2000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();

            newFileList.splice(index, 1);

            this.fileList = newFileList;
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList, file];

            return false;
        },
        handleChange(info) {
            let fileList = [...info.fileList];

            if (fileList.length > 1) {
                fileList = fileList.slice(-1);

                fileList = fileList.map(file => {
                    if (file.response) {
                        file.url = file.response.url;
                    }
                    return file;
                });
                this.fileList = fileList;
            }
        },
        download(url) {
            window.open(window.location.origin + url, '_blank')
        },
    }
}
</script>
